import * as ImportedMath from 'remark-math';

const ex: typeof ImportedMath.default =
  (ImportedMath as any).default || ImportedMath;

export default ex;
